<div #swipe class="swiper" style="z-index: 0; text-align: center">
  <div class="swiper-wrapper">
    <ng-content></ng-content>
  </div>
  <div #swipePrev class="swiper-button-prev"></div>
  <div #swipeNext class="swiper-button-next"></div>
</div>
